export function shouldDismissOverlay(
  target: unknown,
  currentTarget: unknown,
  locked: boolean,
) {
  return !locked && target === currentTarget;
}
